import { StateService } from '@pulse/browser-shared';
import { AnalyticsPlugin, isToggleOn, TrackerConfigurations } from '@pulse/common';
import { combineLatest } from 'rxjs';
import {
    AnalyticsSession,
    DeviceInfoService,
    ExperimentsService,
    SessionService,
} from '../services';
import { DebugService } from '../services/debug.service';

/**
 * Adds default state items such as app, device_id and session_id to state
 */
export class StatePlugin implements AnalyticsPlugin {
    constructor(
        private sessionService: SessionService,
        private experimentsService: ExperimentsService,
        private debug: DebugService,
        private config: TrackerConfigurations,
        private deviceInfo: DeviceInfoService,
        private stateService: StateService,
    ) {}

    init() {
        const infected = this.experimentsService.getInfected();

        if (infected && infected.length) {
            this.stateService.setState({ infected: this.experimentsService.getInfected() });
        } else if (infected && infected.length === 0) {
            this.stateService.removePropertyFromState('infected');
        }
        combineLatest([this.sessionService.session, this.debug.items]).subscribe(([session]) => {
            this.setState(session);
        });
    }

    private setState(session: AnalyticsSession): void {
        const { app } = session;
        const navigatorInfo = this.deviceInfo.getNavigatorInfo();
        const touch = this.deviceInfo.getScreenInfo().touch;
        const cpus = this.deviceInfo.getHardwareInfo().cpus;

        const state: Record<string, unknown> = {
            app: isToggleOn(this.config.stateEnrichment, 'app') ? app : undefined,
            market: isToggleOn(this.config.stateEnrichment, 'market') ? 'web' : undefined,
            platform: isToggleOn(this.config.stateEnrichment, 'platform') ? 'web' : undefined,
            version: isToggleOn(this.config.stateEnrichment, 'version')
                ? this.config.app_version
                : undefined,
            data: {
                language_code: isToggleOn(this.config.stateEnrichment, 'language_code')
                    ? navigatorInfo.device_language_code
                    : undefined,
                cpus,
                touch,
                browser_platform: navigatorInfo.browser_platform,
            },

            v: isToggleOn(this.config.stateEnrichment, 'pulse_version')
                ? this.config.version
                : undefined,
            debug: this.debug.enabled('debugger'),
        };

        this.stateService.setState(state);
    }
}
